import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppNgMaterialModule } from '../app-ng-material.module';

import { EntityChartUpdateComponent } from './entity-chart-update/entity-chart-update.component';
import { DeleteTransactionModalComponent } from './entity-chart-update/delete-transaction-modal/delete-transaction-modal.component';
import { AppNgAppkitModule } from '../app-ng-appkit.module';


@NgModule({ declarations: [EntityChartUpdateComponent, DeleteTransactionModalComponent],
    exports: [
        EntityChartUpdateComponent
    ],
    schemas: [NO_ERRORS_SCHEMA], imports: [CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppNgMaterialModule,
        AppNgAppkitModule], })
export class TrialBalanceInventoryModule { }
